import * as React from 'react';
import { Alert, FormField, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { WEBSITE_NAME } from 'src/commons/constants';
import { GalaxiGroupDropdown } from 'src/components/catalog/datasetdetail/accessSelectModal/galaxiGroupDropdown';

export interface GalaxiAccessSelectorProps {
  galaxiGroups: any;
  selectedGalaxiGroup: any;
  setSelectedGalaxiGroup: any;
  selectedPermission: any;
  setSelectedPermission: any;
  galaxiGroupErrorText: string;
  setGalaxiGroupErrorText: any;
  options: any;
  galaxiGroupOptions: any;
}

export const GalaxiAccessSelector = (props: GalaxiAccessSelectorProps) => {
  const groupServiceSupported = props.galaxiGroups != null;
  const onboardedToGalaxi = props.galaxiGroups?.length > 0;

  const alertMessage = () => {
    let alertMsg = `You will be redirected outside of ${WEBSITE_NAME} to continue your subscription.`;
    if (!onboardedToGalaxi) {
      alertMsg = 'To subscribe to this dataset, you must first onboard on the Galaxi platform.';
    }

    return (
      <Alert statusIconAriaLabel='Warning' type='warning'>
        {alertMsg}
      </Alert>
    );
  };

  const getGalaxiGroupForm = () => {
    return onboardedToGalaxi ? (
      <SpaceBetween size={'m'} direction={'vertical'}>
        <GalaxiGroupDropdown
          selectedOption={props.selectedGalaxiGroup}
          onChange={(e) => props.setSelectedGalaxiGroup(e.detail.selectedOption)}
          options={props.options}
          errorText={undefined}
        />
        {alertMessage()}
      </SpaceBetween>
    ) : (
      alertMessage()
    );
  };

  return (
    <>
      {!groupServiceSupported && (
        <FormField>
          <Alert statusIconAriaLabel='Warning' type='warning'>
            You will be redirected outside of {WEBSITE_NAME} to continue your subscription.
          </Alert>
        </FormField>
      )}
      {groupServiceSupported && getGalaxiGroupForm()}
    </>
  );
};
